var _defs, _path, _polygon, _path2, _polygon2, _polygon3, _path3, _polygon4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorTd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.5 70.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #662e86;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #211e1e;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.68,5.59c-15.73,0-28.48,12.75-28.48,28.48,0,6.8,2.38,13.03,6.35,17.93l-6.35,10.56,11.57-5.57c4.73,3.5,10.58,5.57,16.91,5.57,15.73,0,28.49-12.75,28.49-28.49s-12.75-28.48-28.49-28.48M129.51,43.11c-4.99,2.12-10.75-.21-12.86-5.2-2.12-4.99.21-10.75,5.2-12.86,4.99-2.12,10.75.21,12.87,5.2,2.12,4.99-.21,10.75-5.2,12.86"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.58 7.23 10.33 7.23 10.33 5.6 28.59 5.6 28.59 7.23 20.34 7.23 20.34 29.27 18.58 29.27 18.58 7.23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.46,5.6h1.69l11.02,23.66h-1.93l-3.01-6.58h-13.96l-3.01,6.58h-1.83l11.02-23.66ZM44.5,21.11l-6.22-13.59-6.26,13.59h12.48Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.65 5.6 55.4 5.6 55.4 27.65 69.3 27.65 69.3 29.27 53.65 29.27 53.65 5.6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "89.66 5.6 87 5.6 74.98 16.74 74.98 5.6 73.22 5.6 73.22 29.27 74.98 29.27 74.98 18.13 87 29.27 89.66 29.27 76.89 17.43 89.66 5.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.45,64.64v-27.47h10.83c8.61,0,14.58,5.48,14.58,13.76s-5.97,13.72-14.58,13.72h-10.83ZM16.3,59.49h4.98c5.44,0,8.61-3.91,8.61-8.57s-2.97-8.61-8.61-8.61h-4.98v17.18Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.02 64.64 40.02 37.17 59.46 37.17 59.46 42.19 45.87 42.19 45.87 48.16 59.18 48.16 59.18 53.19 45.87 53.19 45.87 59.57 59.46 59.57 59.46 64.64 40.02 64.64"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.74 64.64 61.11 37.17 67.78 37.17 75.4 58.29 82.98 37.17 89.66 37.17 79.07 64.64 71.74 64.64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorTd);
export default __webpack_public_path__ + "static/media/Color TD.ceabe3cdf5c9e572813f113c0ffaa735.svg";
export { ForwardRef as ReactComponent };